import React from "react";

import Avatar from "../assets/Avatar2.png";
import Avatar2 from "../assets/Avatar3.png";
import Avatar3 from "../assets/Avatar7.png";
import Avatar4 from "../assets/Avatar5.png";
import Avatar6 from "../assets/Avatar8.png";

const CandidateChat = () => {
  return (
    <div>
      <div className="flex justify-start items-start flex-row bg-transparent">
        <div className=" flex-1 flex-col gap-6 pt-2">
          <div className="flex self-stretch justify-start items-start flex-col gap-8  pb-[48px] bg-transparent  col-span-12">
            <div className="flex justify-between items-center gap-6 w-full px-8">
              <div className="min-w-[320px] flex flex-1 justify-start items-start flex-col gap-1">
                <p className="self-stretch text-[#181D27] text-2xl  font-semibold">
                  Candidate Chat
                </p>
                <p className="self-stretch text-[#535862] ">
                  Here is your internal communication hub.
                </p>
              </div>
              <div className="flex cursor-pointer items-center flex-row gap-1 py-2.5 px-3.5 bg-[#19BFB7]  rounded-lg ">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.99996 4.16602V15.8327M4.16663 9.99935H15.8333"
                    stroke="white"
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <div className="flex justify-center items-center flex-row px-0.5">
                  <span className="text-[#FFFFFF] text-sm font-semibold">
                    New Chat
                  </span>
                </div>
              </div>
            </div>
            <div className="flex self-stretch justify-start items-start flex-col gap-6">
              <div className="flex self-stretch justify-start items-start flex-col gap-6 px-[32px]">
                <div className="flex self-stretch justify-start items-start flex-row gap-6">
                  <div
                    className="flex justify-start items-start flex-col gap-5 w-[261px]"
                    style={{ width: "261px" }}
                  >
                    <div className="flex self-stretch justify-start items-center flex-row gap-5">
                      <p className="flex-1 text-[#181D27] text-lg  font-medium">
                        Direct Messages
                      </p>
                      <div className="flex justify-center items-center flex-row p-2 cursor-pointer border border-[#D5D7DA]  rounded-lg ">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10 4.16602V15.8327M4.16669 9.99935H15.8334"
                            stroke="#414651"
                            strokeWidth="1.66667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="flex self-stretch justify-start items-start flex-col gap-5">
                      <div className="flex self-stretch justify-start items-end flex-row gap-3 p-2 bg-[#FAFFFC] rounded-2xl">
                        <div className="flex justify-end items-center  rounded-[200px] ">
                          <div>
                            <img src={Avatar3} alt="" />
                          </div>
                          <div className="flex justify-center items-center flex-row bg-[#12B76A] border-solid border-[#FFFFFF] border-[1.5px] rounded-md"></div>
                        </div>
                        <div className="flex flex-1 justify-start items-start flex-col gap-1">
                          <div className="flex self-stretch justify-start items-center flex-row gap-1">
                            <p className="flex-1 text-[#414651]  font-semibold">
                              Ella Martinez
                            </p>
                            <span className="text-[#535862] text-[10px] ">
                              10:30 AM
                            </span>
                          </div>
                          <p className="self-stretch text-[#535862] text-sm ">
                            Hey! How are you doing
                          </p>
                        </div>
                      </div>
                      <div className="flex self-stretch justify-start items-end flex-row gap-3 p-2">
                        <div className="flex justify-end items-center rounded-[200px] ">
                          <div>
                            <img src={Avatar6} alt="" />
                          </div>
                          <div className="flex justify-center items-center flex-row bg-[#12B76A] border-solid border-[#FFFFFF] border-[1.5px] rounded-md"></div>
                        </div>
                        <div className="flex flex-1 justify-start items-start flex-col gap-1">
                          <div className="flex self-stretch justify-start items-center flex-row gap-1">
                            <p className="flex-1 text-[#414651] font-semibold">
                              Savannah Nguyen
                            </p>
                            <span className="text-[#535862] text-[10px]">
                              10:30 AM
                            </span>
                          </div>
                          <p className="self-stretch text-[#535862] text-sm">
                            Hey! How are you doing
                          </p>
                        </div>
                      </div>
                      <div className="flex self-stretch justify-start items-end flex-row gap-3 p-2">
                        <div className="flex justify-end items-center flex-row  rounded-[200px] ">
                          <div>
                            <img src={Avatar} alt="" />
                          </div>
                          <div className="flex justify-center items-center flex-row bg-[#12B76A] border-solid border-[#FFFFFF] border-[1.5px] rounded-md"></div>
                        </div>
                        <div className="flex flex-1 justify-start items-start flex-col gap-1">
                          <div className="flex self-stretch justify-start items-center flex-row gap-1">
                            <p className="flex-1 text-[#414651]  font-semibold">
                              Albert Flores
                            </p>
                            <span className="text-[#535862] text-[10px] ">
                              10:30 AM
                            </span>
                          </div>
                          <p className="self-stretch text-[#535862] text-sm ">
                            Hey! How are you doing
                          </p>
                        </div>
                      </div>
                      <div className="flex self-stretch justify-start items-end flex-row gap-3 p-2">
                        <div className="flex justify-end items-center flex-row rounded-[200px] ">
                          <div>
                            <img src={Avatar4} alt="" />
                          </div>
                          <div className="flex justify-center items-center flex-row bg-[#12B76A] border-solid border-[#FFFFFF] border-[1.5px] rounded-md"></div>
                        </div>
                        <div className="flex flex-1 justify-start items-start flex-col gap-1">
                          <div className="flex self-stretch justify-start items-center flex-row gap-1">
                            <p className="flex-1 text-[#414651]  font-semibold">
                              Theresa Webb
                            </p>
                            <span className="text-[#535862] text-[10px] ">
                              10:30 AM
                            </span>
                          </div>
                          <p className="self-stretch text-[#535862] text-sm ">
                            Hey! How are you doing
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="flex self-stretch justify-start items-end flex-row gap-3 p-2">
                      <div className="flex justify-end items-center rounded-[200px] ">
                        <div>
                          <img src={Avatar2} alt="" />
                        </div>
                        <div className="flex justify-center items-center flex-row bg-[#12B76A] border-solid border-[#FFFFFF] border-[1.5px] rounded-md"></div>
                      </div>
                      <div className="flex flex-1 justify-start items-start flex-col gap-1">
                        <div className="flex self-stretch justify-start items-center flex-row gap-1">
                          <p className="flex-1 text-[#414651]  font-semibold">
                            Neighborhood Hub
                          </p>
                          <span className="text-[#535862] text-[10px] ">
                            10:30 AM
                          </span>
                        </div>
                        <p className="self-stretch text-[#535862] text-sm ">
                          Hey! How are you.. - Ella
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-1 justify-end items-start flex-col gap-6 border-solid border-[#E9EAEB] border rounded-3xl h-[703px] relative">
                    <div className="flex self-stretch justify-end items-center flex-col gap-8 px-[24px] h-[730px]">
                      <div className="flex self-stretch justify-start items-start flex-col gap-4">
                        <div className="flex self-stretch justify-start items-start flex-row"></div>

                        <div className="flex self-stretch justify-start items-start flex-row">
                          <div className="max-w-[312px] flex flex-1 justify-start items-start flex-row gap-3">
                            <div>
                              <div>
                                <img src={Avatar4} alt="" />
                              </div>

                              <div
                                className="bg-[#17B26A] border-solid border-[#FFFFFF] border-[1.5px] rounded-full absolute"
                                style={{
                                  right: "0px",
                                  width: "10px",
                                  bottom: "0px",
                                  height: "10px",
                                }}
                              ></div>
                            </div>
                            <div className="flex flex-1 justify-start items-start flex-col gap-1.5">
                              <div className="flex self-stretch justify-start items-center flex-row gap-2">
                                <p className="flex-1 text-[#414651] text-sm  font-medium">
                                  Lana Steiner
                                </p>
                                <span className="text-[#535862] text-xs ">
                                  Thursday 11:40am
                                </span>
                              </div>
                              <div className="flex self-stretch justify-start items-center flex-row gap-2 py-2.5 px-3.5 bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-tr-lg rounded-br-lg rounded-bl-lg">
                                <div className="flex flex-1 justify-start items-start flex-row gap-3">
                                  <div
                                    className="w-[40px] h-[40px] relative"
                                    style={{ width: "40px" }}
                                  >
                                    <svg
                                      width="32"
                                      height="40"
                                      viewBox="0 0 32 40"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M0.75 4C0.75 2.20508 2.20508 0.75 4 0.75H20C20.1212 0.75 20.2375 0.798159 20.3232 0.883885L31.1161 11.6768C31.2018 11.7625 31.25 11.8788 31.25 12V36C31.25 37.7949 29.7949 39.25 28 39.25H4C2.20507 39.25 0.75 37.7949 0.75 36V4Z"
                                        stroke="#D5D7DA"
                                        strokeWidth="1.5"
                                      />
                                      <path
                                        d="M20 0.5V8C20 10.2091 21.7909 12 24 12H31.5"
                                        stroke="#D5D7DA"
                                        strokeWidth="1.5"
                                      />
                                    </svg>
                                    <div
                                      className="flex justify-start items-start flex-row gap-2 py-0.5 px-[3px] bg-[#D92D20] rounded-sm absolute"
                                      style={{
                                        top: "45.00%",
                                        bottom: "15.00%",
                                        height: "calc(100% - 45.00% - 15.00%)",
                                        left: "2.50%",
                                        right: "32.50%",
                                        width: "calc(100% - 2.50% - 32.50%)",
                                      }}
                                    >
                                      <span className="text-[#FFFFFF] text-[10px]  text-center font-bold">
                                        PDF
                                      </span>
                                    </div>
                                  </div>
                                  <div className="flex flex-1 justify-start items-start flex-col gap-1">
                                    <div className="flex self-stretch justify-start items-start flex-col">
                                      <p className="self-stretch text-[#414651] text-sm  font-medium">
                                        Tech requirements.pdf
                                      </p>
                                      <p className="self-stretch text-[#535862] text-sm ">
                                        1.2 MB
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="flex self-stretch justify-end items-start flex-row">
                          <div className="max-w-[176px] flex flex-1 justify-end items-start flex-row gap-3">
                            <div className="flex flex-1 justify-start items-start flex-col gap-1.5">
                              <div className="flex self-stretch justify-start items-center flex-row gap-2">
                                <p className="flex-1 text-[#414651] text-sm  font-medium">
                                  You
                                </p>
                                <span className="text-[#535862] text-xs ">
                                  Thursday 11:41am
                                </span>
                              </div>
                              <div className="flex self-stretch justify-start items-center flex-row gap-2 py-2.5 px-3.5 bg-[#009C97] rounded-tl-lg rounded-br-lg rounded-bl-lg">
                                <p className="flex-1 text-[#FFFFFF] ">
                                  Awesome! Thanks.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="flex self-stretch justify-start items-start flex-row">
                          <div className="max-w-[312px] flex flex-1 justify-start items-start flex-row gap-3">
                            <div>
                              <div>
                                <img src={Avatar3} alt="" />
                              </div>
                              <div
                                className="bg-[#17B26A] border-solid border-[#FFFFFF] border-[1.5px] rounded-full absolute"
                                style={{
                                  right: "0px",
                                  width: "10px",
                                  bottom: "0px",
                                  height: "10px",
                                }}
                              ></div>
                            </div>
                            <div className="flex flex-1 justify-start items-start flex-col gap-1.5">
                              <div className="flex self-stretch justify-start items-center flex-row gap-2">
                                <p className="flex-1 text-[#414651] text-sm  font-medium">
                                  Demi Wilkinson
                                </p>
                                <span className="text-[#535862] text-xs ">
                                  Thursday 11:44am
                                </span>
                              </div>
                              <div className="flex self-stretch justify-start items-center flex-row gap-2 py-2.5 px-3.5 bg-[#FAFAFA] border-solid border-[#E9EAEB] border rounded-tr-lg rounded-br-lg rounded-bl-lg">
                                <p className="flex-1 text-[#181D27] ">
                                  Good timing — was just looking at this.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flex self-stretch justify-start items-center flex-row gap-2">
                        <div className="flex-1 bg-[#E9EAEB] h-px"></div>
                        <span className="text-[#535862] text-sm  text-center font-medium">
                          Today
                        </span>
                        <div className="flex-1 bg-[#E9EAEB] h-px"></div>
                      </div>
                      <div className="flex self-stretch justify-start items-start flex-col gap-4">
                        <div className="flex self-stretch justify-start items-start flex-row">
                          <div className="max-w-[312px] flex flex-1 justify-start items-start flex-row gap-3">
                            <div className="rounded-full w-[40px] h-[40px] relative">
                              <div>
                                <img src={Avatar2} alt="" />
                              </div>
                              <div
                                className="bg-[#17B26A] border-solid border-[#FFFFFF] border-[1.5px] rounded-full absolute"
                                style={{
                                  right: "0px",
                                  width: "10px",
                                  bottom: "0px",
                                  height: "10px",
                                }}
                              ></div>
                            </div>
                            <div className="flex flex-1 justify-start items-start flex-col gap-1.5">
                              <div className="flex self-stretch justify-start items-center flex-row gap-2">
                                <p className="flex-1 text-[#414651] text-sm  font-medium">
                                  Phoenix Baker
                                </p>
                                <span className="text-[#535862] text-xs ">
                                  Friday 2:20pm
                                </span>
                              </div>
                              <div className="flex self-stretch justify-start items-center flex-row gap-2 py-2.5 px-3.5 bg-[#FAFAFA] border-solid border-[#E9EAEB] border rounded-tr-lg rounded-br-lg rounded-bl-lg">
                                <p className="flex-1 text-[#181D27] ">
                                  Hey Olivia, can you please review the latest
                                  design when you can?
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="flex self-stretch justify-end items-start flex-row">
                          <div className="max-w-[272px] flex flex-1 justify-end items-start flex-row gap-3">
                            <div className="flex flex-1 justify-start items-start flex-col gap-1.5">
                              <div className="flex self-stretch justify-start items-center flex-row gap-2">
                                <p className="flex-1 text-[#414651] text-sm  font-medium">
                                  You
                                </p>
                                <span className="text-[#535862] text-xs ">
                                  Friday 2:20pm
                                </span>
                              </div>
                              <div className="flex self-stretch justify-start items-center flex-row gap-2 py-2.5 px-3.5 bg-[#009C97] rounded-tl-lg rounded-br-lg rounded-bl-lg">
                                <p className="flex-1 text-[#FFFFFF] ">
                                  Sure thing, I’ll have a look today.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex self-stretch justify-start items-center flex-col border-solid border-[#E9EAEB] border-t">
                      <div className="flex self-stretch justify-start items-end flex-col gap-3 py-4 px-[24px]">
                        <div className="flex self-stretch justify-start items-start flex-row gap-3">
                          <div className="flex flex-1 justify-start items-start flex-col gap-1.5">
                            <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                              <div className="flex self-stretch justify-start items-start flex-row bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                                <div className="flex flex-1 justify-start items-center flex-row gap-2 py-2.5 pl-3.5">
                                  <div className="flex flex-1 justify-start items-start flex-row gap-2">
                                    <p className="flex-1 text-[#717680] ">
                                      Message
                                    </p>
                                  </div>
                                </div>
                                <div className="flex self-stretch justify-start items-center flex-row gap-1 py-2.5 px-3.5">
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M17.6271 9.08247L10.1141 16.5955C8.40556 18.304 5.63546 18.304 3.92692 16.5955C2.21837 14.8869 2.21837 12.1168 3.92692 10.4083L11.4399 2.89529C12.579 1.75626 14.4257 1.75626 15.5647 2.89529C16.7037 4.03432 16.7037 5.88105 15.5647 7.02008L8.34633 14.2385C7.77682 14.808 6.85345 14.808 6.28394 14.2385C5.71442 13.6689 5.71442 12.7456 6.28394 12.1761L12.6184 5.84157"
                                      stroke="#A4A7AE"
                                      strokeWidth="1.66667"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex justify-center items-center flex-row p-3 bg-[#009C97] border-solid border-[undefined] border-2 rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05),inset_0px_-2px_0px_0px_rgba(10,13,18,0.05),inset_0px_0px_0px_1px_rgba(10,13,18,0.18)]">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.74964 11.2501L17.4996 2.50014M8.85596 11.5235L11.0461 17.1552C11.239 17.6513 11.3355 17.8994 11.4745 17.9718C11.595 18.0346 11.7385 18.0347 11.8591 17.972C11.9982 17.8998 12.0949 17.6518 12.2884 17.1559L17.7804 3.08281C17.9551 2.63516 18.0424 2.41133 17.9946 2.26831C17.9532 2.1441 17.8557 2.04663 17.7315 2.00514C17.5885 1.95736 17.3646 2.0447 16.917 2.21939L2.84386 7.71134C2.34796 7.90486 2.10001 8.00163 2.02775 8.14071C1.96512 8.26129 1.9652 8.40483 2.02798 8.52533C2.1004 8.66433 2.34846 8.7608 2.84458 8.95373L8.47625 11.1438C8.57696 11.183 8.62731 11.2026 8.66972 11.2328C8.7073 11.2596 8.74016 11.2925 8.76697 11.3301C8.79721 11.3725 8.8168 11.4228 8.85596 11.5235Z"
                                stroke="white"
                                strokeWidth="1.66667"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="flex justify-between rounded-t-3xl items-start flex-row gap-4 pt-3 pb-2 px-6 bg-[#FFFFFF] shadow-[_0px_4px_26px_0px_rgba(0,0,0,0.08)] absolute w-[831px]"
                      style={{
                        top: "0px",
                        height: "60px",
                        left: "0px",
                        right: "0px",
                        width: "calc(100% - 0px - 0px)",
                      }}
                    >
                      <div className="flex items-center gap-2">
                        <div>
                          <img src={Avatar3} alt="" className="w-10 h-10" />
                        </div>
                        <div className="flex flex-1 justify-start items-start flex-col">
                          <p className="self-stretch text-[#181D27] text-lg  font-medium leading-7">
                            Ella Martinez
                          </p>
                        </div>
                      </div>

                      <span className="text-gray-600 text-center cursor-pointer text-xl font-bold ">
                        &#8942;
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateChat;
